module.exports = __webpack_public_path__ + "img/star.b7a7214d.jpg";